// import { Dom, Event, Text, Type } from 'main.core';
// import LazyLoader from './lazy-loader';
import { Loc } from 'main.core';
export class ProductLabel {

    constructor(params) {
        this.ID = params.ID
        this.SORT = params.SORT
        this.XML_ID = params.XML_ID
        this.NAME = params.NAME
        this.CODE = params.CODE
        this.DESCRIPTION = params.DESCRIPTION
        this.HELP = params.HELP
        this.IMAGE = params.IMAGE
        this.TYPE = params.TYPE
        this.LINK = params.LINK || params.SRC
        if (!this.TYPE && this.LINK) // TODO верменное решение определение типа по url
            this.TYPE = this.LINK.indexOf('action') ? 'STOCK' : '';
        this.TITLE = params.TITLE
        if (this.TYPE && !this.TITLE)
            this.TITLE = Loc.getMessage('LABEL_' + this.TYPE + '_TITLE') + ': ' + this.NAME
        this.ALT = params.ALT
        if (this.TYPE && !this.ALT)
            this.ALT = Loc.getMessage('LABEL_' + this.TYPE + '_ALT') + ': ' + this.NAME
    }
}
